module.exports = __webpack_public_path__ + "static/media/warning.6785d770.svg";